// export const API_ADDRESS = "http://192.168.50.234:10300/RvWebsite0302";
// export const API_ADDRESS_TAOCAN = "http://192.168.50.234:10300/RvWebsite0301";
// export const API_ADDRESS_ZHANGHAO = "http://192.168.50.234:10300/RvWebsite0302";
// export const API_ADDRESS_DINGDAN = "http://192.168.50.234:10300/RvWebsite0303";

// export const API_ADDRESS = "http://192.168.50.234:10302/api";
// export const API_ADDRESS_TAOCAN = "http://192.168.50.234:10302/api";
// export const API_ADDRESS_ZHANGHAO = "http://192.168.50.234:10302/api";
// export const API_ADDRESS_DINGDAN = "http://192.168.50.234:10302/api";

export const API_ADDRESS = "https://www.cicadasing.com/api";
export const API_ADDRESS_TAOCAN = "https://www.cicadasing.com/api";
export const API_ADDRESS_ZHANGHAO = "https://www.cicadasing.com/api";
export const API_ADDRESS_DINGDAN = "https://www.cicadasing.com/api";

export const SUCCESS_CODE = "0000";
export const AUTHENTICATION_FAILED_CODE = "0002";
export const LOGIN_PATH = "/login";
export const DEFAULT_ROUTE = "/structure";
export const MOBILE_REG = /1[345789]\d{9}$/; 
export const USERNAME_REG = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
export const USERNAME_TIP = "6-16位的数字+字母";
export const PASSWORD_REG = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
export const PASSWORD_TIP = "6-16位的数字+字母";
export const MAIL_REG = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
export const FORCE_REALNAME = true; //是否强制实名


export const ANDROID_DOWNLOAD = "https://play.google.com/store/apps/details?id=com.chirping";
export const IOS_DOWNLOAD = "https://apps.apple.com/cn/app/%E8%9D%89%E9%B8%A3-%E8%87%AA%E7%94%B1%E7%A7%81%E5%AF%86%E7%9A%84%E8%81%8A%E5%A4%A9/id1531986175";
export const APK_DOWNLOAD = "https://www.cicadasing.com/apk/Cicadasing.apk";